import { render, staticRenderFns } from "./PanelCompetitionMessagesSms.vue?vue&type=template&id=3ba25948&scoped=true&"
import script from "./PanelCompetitionMessagesSms.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionMessagesSms.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionMessagesSms.vue?vue&type=style&index=0&id=3ba25948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba25948",
  null
  
)

export default component.exports